import {defineAsyncComponent} from 'vue';

const SettingDvcFilePopup = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/SettingDvcFilePopup.vue'));
const ChooseVoucherDvcFilePopup = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcFile/ChooseVoucherDvcFilePopup.vue'),
);
const ChooseApprover = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/ChooseApprover.vue'));
const DVCFileDetail = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/DVCFileDetail.vue'));
const C202a = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/C2-02a.vue'));
const C202b = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/C2-02b.vue'));
const C203 = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/C2-03.vue'));
const C402a = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/C4-02a.vue'));
const C402c = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/C4-02c.vue'));
const C205a = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/C2-05a.vue'));
const M07 = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/M07.vue'));
const M04b = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/M04b.vue'));
const M04a = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/M04a.vue'));
const M05 = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/M05.vue'));
const M09 = defineAsyncComponent(() => import('@/views/etreasury/transctionrecordDVC/M09.vue'));

const BannerKBDTPopup = defineAsyncComponent(() => import('@/views/etreasury/banner/BannerKBDTPopup.vue'));
const LookUpBusinessInformation = defineAsyncComponent(() =>
  import('@/views/etreasury/lookUpBusinessInformation/LookUpBusinessInformationPopup.vue'),
);
const LookUpBusinessDocumentPreview = defineAsyncComponent(() =>
  import('@/views/etreasury/lookUpBusinessInformation/LookUpBusinessDocumentPreview.vue'),
);
// Thông báo trương trình hỗ trợ quết toán qua zoom
const HelpSettlementZoomPopup = defineAsyncComponent(() =>
  import('@/views/etreasury/banner/HelpSettlementZoomPopup.vue'),
);
// Thông báo hỗ trợ đối chiếu kho bạc qua zoom
const HelpTreasuryZoomPopup = defineAsyncComponent(() => import('@/views/etreasury/banner/HelpTreasuryZoomPopup.vue'));
const HelpTrainZoomPopup = defineAsyncComponent(() => import('@/views/etreasury/banner/HelpTrainZoomPopup.vue'));

const dvcExportSubmitData = defineAsyncComponent(() => import('@/views/etreasury/dvc_export/DVCExportSubmitData.vue'));

const DCSDFileDetail = defineAsyncComponent(() => import('@/views/etreasury/dcsdFile/DCSDFileDetail.vue'));

const SettingDcsdFilePopup = defineAsyncComponent(() => import('@/views/etreasury/dcsdFile/SettingDcsdFilePopup.vue'));

const UpdateBankAccountPopup = defineAsyncComponent(() => import('@/views/etreasury/dcsdFile/UpdateBankAccount.vue'));

const DvcLoginPopup = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/DvcLoginPopup.vue'));
const LinkedFileCodePopup = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/LinkedFileCodePopup.vue'));
export function registerETreasury(app) {
  app.component('SettingDvcFilePopup', SettingDvcFilePopup);
  app.component('ChooseVoucherDvcFilePopup', ChooseVoucherDvcFilePopup);
  app.component('ChooseApprover', ChooseApprover);
  app.component('DVCFileDetail', DVCFileDetail);
  app.component('C202a', C202a);
  app.component('C202b', C202b);
  app.component('C203', C203);
  app.component('C402a', C402a);
  app.component('C402c', C402c);
  app.component('C205a', C205a);
  app.component('M07', M07);
  app.component('M09', M09);
  app.component('M04b', M04b);
  app.component('M04a', M04a);
  app.component('M05', M05);
  app.component('DVCExportSubmitData', dvcExportSubmitData);
  app.component('DCSDFileDetail', DCSDFileDetail);
  app.component('SettingDcsdFilePopup', SettingDcsdFilePopup);
  app.component('DvcLoginPopup', DvcLoginPopup);
  app.component('BannerKBDTPopup', BannerKBDTPopup);
  app.component('HelpSettlementZoomPopup', HelpSettlementZoomPopup);
  app.component('HelpTreasuryZoomPopup', HelpTreasuryZoomPopup);
  app.component('HelpTrainZoomPopup', HelpTrainZoomPopup);
  app.component('UpdateBankAccountPopup', UpdateBankAccountPopup);
  app.component('LookUpBusinessInformation', LookUpBusinessInformation);
  app.component('LookUpBusinessDocumentPreview', LookUpBusinessDocumentPreview);
  app.component('LinkedFileCodePopup', LinkedFileCodePopup);
}
